import { Trait } from '../../trait.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { Die, DieMaterial, DieType, type DieCreation } from '../../die.type';
import type { Damage } from '../../damage.type';

export class ManyHeadsTrait extends Trait {
  static baseType = TraitType.ManyHeads;
  static baseTitle = 'Many Heads Makes Fight Work';
  static baseText =
    'When taking 4 or more damage, gain 1 extra head. At the start of your turn, gain 1 die for each head.';
  static baseIcon = 'trait';

  type = ManyHeadsTrait.baseType;
  title = ManyHeadsTrait.baseTitle;
  text = ManyHeadsTrait.baseText;
  icon = ManyHeadsTrait.baseIcon;

  init() {
    super.init();
    this.stacks = 0;
  }

  damageIn(damage: Damage): void {
    if (damage.value >= 4) {
      this.stacks++;
    }
  }

  getDice(dice: Array<Die>): Array<DieCreation> {
    let array: Array<DieCreation> = [];

    for (let i = 0; i < this.stacks; i++) {
      array.push({
        type: DieType.Maw,
        level: 0,
        material: DieMaterial.Normal,
      });
    }

    return array;
  }
}

TraitRegistry.register(ManyHeadsTrait.baseType, ManyHeadsTrait);
